/**
 * Format the "atom-as-subject" symbol used at the start of an atom description.
 *
 * Self-contained copy used by `classifyPrimaryConnection`. The canonical copy
 * for the alt-text pipeline lives in `@alchemiesolns/svg-interactive`
 * (`atomDescription.ts`); we keep this one local to avoid a circular package
 * dependency (svg-interactive → molecule-descriptions → svg-interactive).
 */
const ORGANIC_OVERRIDES = new Set(["Pr", "R", "Ac", "Cn", "Ts"]);
const SUBSCRIPT_DIGITS = "₀₁₂₃₄₅₆₇₈₉";

function toSubscript(n: number): string {
    return String(n)
        .split("")
        .map(d => SUBSCRIPT_DIGITS[parseInt(d, 10)] ?? d)
        .join("");
}

export function chemicalAtomSymbol(symbol: string, hydrogenCount: number): string {
    if (symbol === "C") return "C";
    if (ORGANIC_OVERRIDES.has(symbol)) return symbol;
    if (hydrogenCount <= 0) return symbol;
    if (hydrogenCount === 1) return `${symbol}H`;
    return `${symbol}H${toSubscript(hydrogenCount)}`;
}
